import {
  Component,
  Input,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import Swal from 'sweetalert2';
import { GoogleMapsInputComponent } from '../google-maps-input/google-maps-input.component';
import {
  ISetUpdateAuthorizationBody,
  ISetUpdateAuthorizationResponse,
} from 'src/app/feature/BNPL/shared/models/updateAuthorization.model';
import { UpdateAuthorizationService } from 'src/app/feature/BNPL/shared/services/update-authorization.service';

@Component({
  selector: 'app-update-data',
  templateUrl: './update-data.component.html',
  styleUrls: ['./update-data.component.css'],
})
export class UpdateDataComponent {
  @Input() numberId: string = '';
  @Output() requireUpdate = new EventEmitter<boolean>();
  @ViewChild(GoogleMapsInputComponent)
  googleMapsInputComponent!: GoogleMapsInputComponent;

  selectedDate: string = '';
  selectedDirection: string = '';
  step: number = 1;
  dataUpdateResponse: ISetUpdateAuthorizationResponse | null = null;
  status: boolean | null = null;
  maxDate: string = '';

  constructor(private updateAuthorizationService: UpdateAuthorizationService) {}

  ngOnInit() {
    const hoy = new Date();
    const fecha = new Date(
      hoy.getFullYear() - 18,
      hoy.getMonth(),
      hoy.getDate()
    );
    this.maxDate = fecha.toISOString().split('T')[0];
  }

  toStep2() {
    this.step = 2;
    setTimeout(() => {
      this.googleMapsInputComponent.initializeAutocomplete();
    }, 0);
  }

  alertWait(text: string) {
    Swal.fire({
      title: text,
      allowOutsideClick: false,
      imageUrl: '../../../../assets/img/LogoApprobe.gif',
      showConfirmButton: false,
      customClass: {
        image: 'alertImage',
      },
    });
  }

  handleSetUpdateAuthorization() {
    this.alertWait('Validando...');
    const date = this.selectedDate.split('-');
    const formatDate = `${date[2]}/${date[1]}/${date[0]}`;
    const body: ISetUpdateAuthorizationBody = {
      action: 'UPDATE',
      numberId: this.numberId,
      birthDate: formatDate,
      direccion: this.selectedDirection,
    };
    this.updateAuthorizationService.setUpdateAuthorization(body).subscribe({
      next: (response) => {
        this.dataUpdateResponse = response;
        this.status = true;
        Swal.close();
        this.step = 3;
      },
      error: (error) => {
        console.error('Error al actualizar los datos', error);
        this.status = false;
        Swal.close();
        this.step = 3;
      },
    });
  }

  handleEndProcess() {
    if (this.status) {
      document.body.classList.remove('no-scroll');
      this.requireUpdate.emit(false);
    } else {
      document.body.classList.remove('no-scroll');
      window.location.href = '/';
    }
  }
}
